/*
  Madison Center: ajustes propios que necesitan JavaScript (se carga en todas las páginas desde layout/theme.liquid).

  1) PRECIOS EN UNA SOLA FILA (pedido de Jonathan 2026-10-02): en el celular el logo de Madison, el precio y el precio
     tachado van siempre en una fila. Si en una tarjeta no caben (precios largos con descuento, ej. $217.99 y $256.99),
     primero se achica el precio TACHADO (hasta 75%) y, solo si aún no cabe, también el precio; todo solo en esa
     tarjeta y el logo no cambia. Los tamaños normales están en madison.css.
  2) BOTÓN "Opciones" (pedido de Jonathan 2026-10-02): en las tarjetas de productos con tallas o colores el botón decía
     "Escoger opción" (tema) o "Escoger opciones" (buscador); era más ancho que "Agregar" y le quitaba espacio al precio.
     Se cambia aquí y no en locales/es.json porque el editor de idiomas de Shopify puede sobrescribir ese archivo.

  Para que la página vaya rápida (revisión 2026-10-02):
  - Cada fila de precio se ajusta SOLA cuando aparece o cambia de ancho (ResizeObserver), no todas cada vez que algo
    se mueve en la página (fotos que cargan, carruseles, menús).
  - Los botones se revisan solo en lo que se agrega a la página (buscador, panel de sugerencias, "Ver todo").
  (Las fotos del panel de sugerencias ya vienen en 250 px desde assets/algolia-hooks.js.)
*/
(function () {
  var CELULAR = window.matchMedia('(max-width: 640px)');
  var FILAS = '.product-item__price-list, .ais-hit--price, .aa-ItemContentPrice';
  var TEXTOS = '.price, .price-container > b, .ais-hit--price-striked, .aa-ItemContentPriceCurrent';
  var TACHADOS = '.price--compare, .ais-hit--price-striked';
  var BOTONES_OPCIONES = 'a.product-item__action-button, .ais-hit--cart-button, .ais-hit--cart-button > span';
  var ESCOGER_OPCION = /^\s*Escoger opci(ó|o)n(es)?\s*$/i;

  function lista(raiz, selector) {
    return Array.prototype.slice.call(raiz.querySelectorAll(selector));
  }

  // Como lista(), pero también incluye la propia raíz si coincide
  function buscar(raiz, selector) {
    var encontrados = lista(raiz, selector);
    if (raiz.matches && raiz.matches(selector)) encontrados.unshift(raiz);
    return encontrados;
  }

  function noCabe(fila) {
    return fila.clientWidth > 0 && fila.scrollWidth > fila.clientWidth + 1;
  }

  function tamano(t, px) {
    t.style.setProperty('font-size', px.toFixed(1) + 'px', 'important');
  }

  function ajustarFila(fila) {
    var textos = lista(fila, TEXTOS);
    var tachados = lista(fila, TACHADOS);
    var normal = textos.map(function (t) { return parseFloat(getComputedStyle(t).fontSize); });
    var escala;

    // 1) Solo el tachado, hasta el 75% de su tamaño
    for (escala = 0.95; escala >= 0.75 && noCabe(fila); escala -= 0.05) {
      textos.forEach(function (t, i) { if (tachados.indexOf(t) >= 0) tamano(t, normal[i] * escala); });
    }
    // 2) Si aún no cabe, el precio y el tachado juntos (el tachado parte del 75%)
    for (escala = 0.95; escala >= 0.6 && noCabe(fila); escala -= 0.05) {
      textos.forEach(function (t, i) { tamano(t, normal[i] * (tachados.indexOf(t) >= 0 ? 0.75 : 1) * escala); });
    }
  }

  // Ajusta solo las filas indicadas: primero todas vuelven al tamaño normal y luego se miden
  // (todas las escrituras juntas y después las medidas: la página se recalcula una sola vez)
  function ajustar(filas) {
    filas.forEach(function (fila) {
      lista(fila, TEXTOS).forEach(function (t) { t.style.removeProperty('font-size'); });
    });
    if (!CELULAR.matches) return;
    filas.filter(noCabe).forEach(ajustarFila);
  }

  function ajustarTodas() {
    ajustar(lista(document, FILAS));
  }

  // Cada fila de precio se vigila: el navegador avisa cuando aparece o cambia de tamaño
  // (fila que se despliega, cambio de vista lista/cuadrícula, giro del teléfono)
  var vigiladas = window.WeakSet ? new WeakSet() : null;
  var observador = window.ResizeObserver && vigiladas ? new ResizeObserver(function (avisos) {
    ajustar(avisos.map(function (a) { return a.target; }));
  }) : null;

  function vigilarFilas(raiz) {
    var nuevas = buscar(raiz, FILAS);
    if (!observador) { if (nuevas.length) ajustar(nuevas); return; }
    nuevas.forEach(function (fila) {
      if (vigiladas.has(fila)) return;
      vigiladas.add(fila);
      observador.observe(fila);
    });
  }

  function cambiarTextoOpciones(raiz) {
    buscar(raiz, BOTONES_OPCIONES).forEach(function (boton) {
      if (boton.children.length === 0 && ESCOGER_OPCION.test(boton.textContent)) boton.textContent = 'Opciones';
    });
  }

  function revisar(raiz) {
    cambiarTextoOpciones(raiz);
    vigilarFilas(raiz);
  }

  // Lo que ya está en la página
  revisar(document);

  // Lo que se agrega después (buscador, panel de sugerencias, "cargar más", cambio de vista)
  new MutationObserver(function (cambios) {
    var filasCambiadas = [];
    cambios.forEach(function (cambio) {
      Array.prototype.forEach.call(cambio.addedNodes, function (nodo) {
        if (nodo.nodeType === 1) revisar(nodo);
      });
      // Texto cambiado dentro de un botón o de una fila de precio que ya estaba (el buscador reutiliza tarjetas)
      var dentro = cambio.target;
      if (dentro.nodeType !== 1) return;
      if (dentro.matches(BOTONES_OPCIONES)) cambiarTextoOpciones(dentro);
      var fila = dentro.closest(FILAS);
      if (fila && filasCambiadas.indexOf(fila) < 0) filasCambiadas.push(fila);
    });
    if (filasCambiadas.length) ajustar(filasCambiadas);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Cuando terminan de cargar las letras (cambian el ancho de los precios) y al pasar de celular a computadora
  window.addEventListener('load', ajustarTodas);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustarTodas);
  if (CELULAR.addEventListener) CELULAR.addEventListener('change', ajustarTodas);
  else if (CELULAR.addListener) CELULAR.addListener(ajustarTodas);
})();
